import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";

const CONFIG: SpokePageConfig = {
  slug: "estate-planning-lawyer-web-design-colorado",
  metaTitle: "Estate Planning Lawyer Web Design in Colorado | Websites That Book Jobs",
  metaDescription:
    "Custom estate planning lawyer web design across Colorado — fast, mobile-first, conversion-tested sites built to turn local searches into booked work. Owner-led. Call (719) 419-3935.",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Colorado Springs digital marketing", to: "/colorado-springs" },
  ],
  currentLabel: "Estate Planning Lawyer Web Design Colorado",
  eyebrow: "Estate Planning Lawyer Web Design — Colorado",
  h1: (
    <>
      Estate Planning Lawyer <span className="text-brand-gold">Web Design</span> in Colorado
    </>
  ),
  heroDescription:
    "Hand-coded estate planning lawyer websites that load in under 2 seconds, convert mobile searches, and rank from day one.",
  intro:
    "Estate Planning Lawyer websites lose the lead in the first 4 seconds on a phone. We hand-code fast, mobile-first estate planning lawyer sites with sticky CTAs, dedicated service pages, and conversion-tested intake flows. No bloated templates, no page builders — just a fast custom site that turns local searches into booked work.",
  definition: {
    term: "Estate Planning Lawyer web design in Colorado",
    body: "Estate Planning Lawyer web design is the practice of building conversion-focused, mobile-first websites for estate planning lawyer businesses — with dedicated service pages, clear CTAs, fast load times, and proper local SEO structure baked in from day one.",
  },
  whatWeDo: [
    { title: "Hand-coded for speed", body: "Sub-2-second load with consultation booking above the fold." },
    { title: "Service pages per document", body: "Wills, revocable trusts, irrevocable trusts, POA, healthcare directives, probate — each ranks." },
    { title: "Online consultation booking", body: "Real-time booking integration with Calendly or your case management software." },
    { title: "Educational content", body: "CO-specific guides on probate avoidance, trust funding, and estate tax — earns long-tail traffic." },
    { title: "Attorney bio pages", body: "Each attorney with credentials, philosophy, and direct booking CTA." },
    { title: "Schema and SEO at launch", body: "LegalService, Attorney, FAQPage, Review schema baked in." },
  ],
  whyThisMarket: [
    { heading: "Educational content drives the booking", body: "Estate clients research for months. CO-specific guides build trust before the consultation." },
    { heading: "Document-type pages outrank generic estate pages", body: "Will vs revocable trust vs irrevocable trust are different searches and different conversion paths." },
    { heading: "Probate pages capture urgency", body: "Probate searches are time-sensitive and high-intent — a dedicated probate page closes the call." },
  ],
  relatedLinks: [
    { to: "/colorado-springs", label: "Colorado Springs digital marketing hub" },
    { to: "/colorado-springs-web-design", label: "How our web design process works" },
    { to: "/web-design-pricing", label: "Web design pricing" },
    { to: "/colorado-springs", label: "Colorado Springs digital marketing agency" },
    { to: "/web-design-denver-colorado", label: "Denver web design" },
    { to: "/case-studies", label: "Colorado case studies" },
    { to: "/web-design", label: "Our web design service (all industries)" },
    { to: "/pricing", label: "Web design pricing" },
  ],
  faqs: [
    { q: "How much does a estate planning lawyer website cost in Colorado?", a: "Website packages start at $1,850 one-time. All include one year of hosting and a built-in traffic dashboard. Extra pages are $85 each. Compare all packages or build a plan on our pricing page." },
    { q: "How long does it take to build a estate planning lawyer website?", a: "Typical websites are built in less than 7 business days. Larger sites, migrations, and custom integrations are scoped before work starts." },
    { q: "Will the new site rank from day one?", a: "Existing rankings stay or improve because we build proper 301 redirects from every old URL, keep your domain, and ship with full schema and on-page SEO from launch — not as a phase 2 afterthought." },
    { q: "Do you only serve Colorado Springs estate planning lawyer businesses?", a: "No — we build estate planning lawyer sites for businesses across all of Colorado: Denver, Fort Collins, Pueblo, Castle Rock, Parker, Boulder, and the Front Range." },
  ],
  serviceName: "Estate Planning Lawyer Web Design in Colorado",
  serviceDescription:
    "Hand-coded, mobile-first websites for estate planning lawyer businesses across Colorado. Fast, conversion-focused, and SEO-ready from launch.",
  areaServed: "Colorado",
};

export const Route = createFileRoute("/estate-planning-lawyer-web-design-colorado")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
